import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/header/header.component.ts